/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const HillStartAssistControl = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 28 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M6.67 17.84a1.65 1.65 0 0 0-.44 2.27 1.63 1.63 0 1 0 .44-2.27zm14.17-9.52a1.63 1.63 0 1 0 1.833 2.696A1.63 1.63 0 0 0 20.84 8.32zm-5.05-.65l-3.41.75a7.88 7.88 0 0 0-2 .92c-1 .61-2 1.16-3 1.86a6.52 6.52 0 0 0-2.65 3.34c-.17.37-.09.47.28.29l11-6.9c.16-.08.09-.29-.24-.26h.02zm8.86 2.09a2.87 2.87 0 0 1-1.28 2.32 2.91 2.91 0 0 1-2.64.32l-10.24 6.88a2.91 2.91 0 0 1-3.93 2.64l-1.48.71c-.27.11-.57.11-.84 0a3.92 3.92 0 0 1-1.54-.8 10.11 10.11 0 0 1-2-3.45 1 1 0 0 1 .3-1.19 16.11 16.11 0 0 0 2.58-3.25c1.13-1.66 1.44-2.42 3.15-3.65 1-.74 2-1.29 3.07-1.94a9.35 9.35 0 0 1 2.26-1c1.5-.35 2.94-.65 4.4-1.07L21.8 4.4a6 6 0 0 1 1.64-.35 1.23 1.23 0 0 1 .6.14c.287.226.526.509.7.83l.39.72.19.07a1 1 0 0 1 .41.43l.58 1.24a.89.89 0 0 1-.21 1.07 9.12 9.12 0 0 1-1.45 1.21zM9.11 25.28h18.23V13zM6.94.25l-.21.84 2.68.69-7.17 4.89.49.71 7.05-4.81-.67 2.56.84.22L11 1.3z" /></g>
      </g>
    </svg>
  </span>
);

HillStartAssistControl.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

HillStartAssistControl.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default HillStartAssistControl;
